import { Divider, Grid, Typography } from "@mui/material";
import React from "react";
import WSSelectField from "../../../../Components/Select/WSSelect";
import config from "../../../../Config/clientConfig.json";
import { useFormContext } from "react-hook-form";
import WSTextField, { TextType } from "../../../../Components/TextBox/WSTextBox";
import WSSCheckBoxField from "../../../../Components/CheckBox/WSCheckBox";

export const Others: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
    <>
      <Typography>Others Options</Typography>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12}>
        <WSSCheckBoxField
                        id="updatepurchaserate"
                        {...register('updatepurchaserate')}
                        label="update Purchase Rate with Received Voucher Rate"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                    />
        </Grid>
        <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
                        id="inactivepo"
                        {...register('inactivepo')}
                        label="Inactive Purchase Order After"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                    />
        </Grid>
        <Grid item xs={12} sm={3} mt={1}>
        <Typography>Hours</Typography>

        </Grid>
        <Grid item xs={12} sm={3}>
        <WSTextField
            control={control}
            id="hours"
            {...register("hours")}
            rules={{ required: true }}
            name="hours"
            label=""
            type={TextType.Number}
          />
        </Grid>        
      </Grid>
      <Divider sx={{mt:3}}/>
      <Typography mt={2}>Print Options</Typography>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} sm={6}>
        <Typography>Purchase Order Template</Typography>

        </Grid>
        <Grid item xs={12} sm={3}>
        <WSSelectField
            options={config.templateConfig.staticOptionData}
            rules={{ required: true }}
            {...register("potemplate")}
            id="potemplate"
            control={control}
            defaultValue={"0"}
            label=""
            name="potemplate"
          />
        </Grid>
        <Grid item xs={12} sm={3} >
        <Typography variant="button">Preview</Typography>

        </Grid>
        <Grid item xs={12} sm={6}>
        <Typography>Indent Voucher Template</Typography>

        </Grid>
        <Grid item xs={12} sm={3}>
        <WSSelectField
            options={config.templateConfig.staticOptionData}
            rules={{ required: true }}
            {...register("indentvoucher")}
            id="indentvoucher"
            control={control}
            defaultValue={"0"}
            label=""
            name="indentvoucher"
          />
        </Grid>
        <Grid item xs={12} sm={3} >
        <Typography variant="button">Preview</Typography>

        </Grid>
        <Grid item xs={12} sm={6}>
        <Typography>Goods Receipt Note Template</Typography>

        </Grid>
        <Grid item xs={12} sm={3}>
        <WSSelectField
            options={config.templateConfig.staticOptionData}
            rules={{ required: true }}
            {...register("goodsreceipt")}
            id="goodsreceipt"
            control={control}
            defaultValue={"0"}
            label=""
            name="goodsreceipt"
          />
        </Grid>
        <Grid item xs={12} sm={3} >
        <Typography variant="button">Preview</Typography>

        </Grid>
      </Grid>
    </>
  );
});
